import { Address } from 'medere-ui-framework'
import { HealthEntityNoteDTO } from './HealthEntityNoteDTO'
import { HealthEntityPlanDTO, defaultHealthEntityPlanDTO } from './HealthEntityPlanDTO'
import { PaymentAccount } from './profiledata/ProfileDataFormDTO'

export interface HealthEntitySaveDTO {
  medereentity?: number | null
  commercialname: string
  businessname: string
  externalid: string
  phone: string
  email: string
  active: boolean
  classification: number | null
  classificationdesc: string
  addresses: Address[]
  plans: HealthEntityPlanDTO[]
  notes: HealthEntityNoteDTO[]
  recipeValidator: number | null
  recipeValidatordesc: string
  isThisInstitution: boolean
  studyOrderRepository: number | null
  studyOrderRepositorydesc: string
  idForRecipeValidator: string
  vademecum: number | null
  vademecumdesc: string
  recipeValidatorLogo: string
  appointmentsCategory: string | null
  cuit: string
  documenttype: number | null
  documenttypedesc: string
  documentnumber: string
  vatcategory: number | null
  vatcategorydesc: string
  afipstatus: number | null
  afipstatusdesc: string
  electroniccreditinvoice: boolean
  fiscaladdress: number | null
  fiscaladdressdesc: string
  defaultinvoiceissuerentity: number | null
  definvoiceissuername: string
  defaultpos: number | null
  defaultposname: string
  defaultpaymentmethod: number | null
  defaultpaymentmethodname: string
  defaultbankaccount: number | null
  defaultbankaccountname: string
  iibb: string
  afipalias: string
  afipproductionmode: boolean
  iibbperceptionagent: boolean
  paymentaccounts: PaymentAccount[]
  companystartdate: Date | string | null
  iibbExclusionPercentage: number | null
  iibbFromDate: Date | string | null
  iibbToDate: Date | string | null
}

export const defaultHealthEntitySaveDTO: HealthEntitySaveDTO = {
  medereentity: null,
  commercialname: '',
  businessname: '',
  externalid: '',
  phone: '',
  email: '',
  active: true,
  classification: 1,
  classificationdesc: 'Prestacional',
  addresses: [],
  plans: [],
  notes: [],
  recipeValidator: null,
  recipeValidatordesc: '',
  isThisInstitution: false,
  studyOrderRepository: null,
  studyOrderRepositorydesc: '',
  idForRecipeValidator: '',
  vademecum: null,
  vademecumdesc: '',
  recipeValidatorLogo: '',
  appointmentsCategory: null,
  cuit: '',
  documenttype: null,
  documenttypedesc: '',
  documentnumber: '',
  vatcategory: null,
  vatcategorydesc: '',
  afipstatus: null,
  afipstatusdesc: '',
  electroniccreditinvoice: false,
  fiscaladdress: null,
  fiscaladdressdesc: '',
  defaultinvoiceissuerentity: null,
  definvoiceissuername: '',
  defaultpos: null,
  defaultposname: '',
  defaultpaymentmethod: null,
  defaultpaymentmethodname: '',
  defaultbankaccount: null,
  defaultbankaccountname: '',
  iibb: '',
  afipalias: '',
  afipproductionmode: false,
  iibbperceptionagent: false,
  paymentaccounts: [],
  companystartdate: null,
  iibbExclusionPercentage: null,
  iibbFromDate: null,
  iibbToDate: null,
}

export const emptyHealthEntityPlan: HealthEntityPlanDTO = {
  ...defaultHealthEntityPlanDTO,
  healthentityplan: null,
  name: '',
  description: '',
  healthentity: null,
  healthentityname: '',
}
